import { useEffect, useRef } from 'react';

interface Props {
  open: boolean;
  onClose: () => void;
}

// REQ-FE-029d — ⌘K / Ctrl-K command palette stub. Today this is a
// placeholder modal flagging "search across factures + fournisseurs" as
// the future destination. Real search wiring is its own follow-up REQ.
// Mockup: top-bar `Rechercher...` input with ⌘ K chips.
export function CommandPalette({ open, onClose }: Props) {
  const inputRef = useRef<HTMLInputElement | null>(null);
  useEffect(() => {
    if (!open) return;
    inputRef.current?.focus();
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="cmdk__backdrop"
      role="presentation"
      data-testid="cmdk-backdrop"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="cmdk"
        role="dialog"
        aria-modal="true"
        aria-label="Recherche globale"
        data-testid="cmdk-modal"
      >
        <input
          ref={inputRef}
          type="search"
          className="cmdk__input"
          placeholder="Rechercher factures, fournisseurs, sociétés…"
          data-testid="cmdk-input"
          autoComplete="off"
        />
        <div className="cmdk__hint muted">
          Recherche globale à venir. En attendant, utilise les filtres dans la Boîte de réception ou
          l&apos;Annuaire fournisseurs de chaque société.
        </div>
        <div className="cmdk__foot muted">
          <kbd>Esc</kbd> pour fermer.
        </div>
      </div>
    </div>
  );
}
